<template>
  <v-app-bar app flat color="white" class="header">
    <v-container class="padding-left-right" fluid>
      <v-row no-gutters align="center" justify="center">
        <v-col cols="1" md="3" lg="4">
          <div class="d-flex align-center">
            <a :href="dashboardLink">
              <v-img
                alt="Green Street Logo"
                class="shrink mr-2"
                contain
                src="../assets/logo.svg"
                transition="scale-transition"
              />
            </a>
          </div>
        </v-col>
        <v-col
          cols="11"
          sm="4"
          :class="`d-sm-flex ${
            $vuetify.breakpoint.xsOnly
              ? (isSearchVisible ? 'search-mobile pseudo-visible' : 'pseudo-hidden')
              : ''
          }`"
        >
          <header-search class="flex-grow-1" />
          <v-btn icon title class="hidden-sm-and-up" @click="toggleSearch">
            Cancel
          </v-btn>
        </v-col>
        <v-col
          cols="11"
          sm="5"
          lg="4"
          :class="`d-flex align-center text-center back back-container ${
            $vuetify.breakpoint.xsOnly
              ? (`pseudo-visible ${isSearchVisible ? 'pseudo-hidden' : ''}`)
              : ''
          }`"
        >
          <v-col
            cols="11"
            sm="5"
            lg="4"
            class="back-inner-container d-flex justify-end align-center"
          >
            <p class="back-title subtitle-2 grey--text"> Back to platform: </p>
            <div class="d-flex justify-space-between back-buttons">
              <v-btn title class="back-buttons-prev-btn primary--text" @click="handlePrev">
                <v-icon>
                  mdi-chevron-left
                </v-icon>
                Previous
              </v-btn>
              <v-btn title class="back-buttons-prev-btn primary--text" @click="handleHome">
                <v-icon>
                  mdi-home
                </v-icon>
                Home
              </v-btn>
              <v-btn
                title
                class="back-buttons-prev-btn primary--text hidden-sm-and-up"
                @click="toggleSearch"
              >
                <v-icon>
                  mdi-magnify
                </v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-col>
      </v-row>
    </v-container>
  </v-app-bar>
</template>

<script>
  import HeaderSearch from '../components/inputs/header-search.vue';
  import { mapGetters } from 'vuex';
  import { LS_PREVIOUS_LINK_KEY } from '../constants';
  
  export default {
    name: 'Header',
    components: {
      HeaderSearch
    },
    methods: {
      toggleMock() {
        localStorage.setItem(
          'api-mock-enabled',
          (!this.apiMockEnabled).toString(),
        );
        window.location.reload();
      },
      toggleSearch () {
        this.isSearchVisible = !this.isSearchVisible;
      },
      handleHome () {
        window.location.href = this.dashboardLink;
      },
      handlePrev () {
        const getLink = () => {
          try {
            const prevLink = JSON.parse(window.localStorage.getItem(LS_PREVIOUS_LINK_KEY));
            if (
              !prevLink?.expires ||
              Date.now() > prevLink.expires
            ) {
              return this.dashboardLink;
            }
            return prevLink.link;
          } catch {
            return this.dashboardLink;
          }
        }
        window.location.href = getLink();
      }
    },
    data: () => ({
      dashboardLink: `${process.env.VUE_APP_MAIN_PLATFORM_LINK}dashboard`,
      ecosystem: [
        {
          text: 'vuetify-loader',
          href: 'https://github.com/vuetifyjs/vuetify-loader',
        },
        {
          text: 'github',
          href: 'https://github.com/vuetifyjs/vuetify',
        },
        {
          text: 'awesome-vuetify',
          href: 'https://github.com/vuetifyjs/awesome-vuetify',
        },
      ],
      importantLinks: [
        {
          text: 'Documentation',
          href: 'https://vuetifyjs.com',
        },
        {
          text: 'Chat',
          href: 'https://community.vuetifyjs.com',
        },
        {
          text: 'Made with Vuetify',
          href: 'https://madewithvuejs.com/vuetify',
        },
        {
          text: 'Twitter',
          href: 'https://twitter.com/vuetifyjs',
        },
        {
          text: 'Articles',
          href: 'https://medium.com/vuetify',
        },
      ],
      whatsNext: [
        {
          text: 'Explore components',
          href: 'https://vuetifyjs.com/components/api-explorer',
        },
        {
          text: 'Select a layout',
          href: 'https://vuetifyjs.com/getting-started/pre-made-layouts',
        },
        {
          text: 'Frequently Asked Questions',
          href: 'https://vuetifyjs.com/getting-started/frequently-asked-questions',
        },
      ],
      isProductionMode: process.env.VUE_APP_IS_PRODUCTION === 'true',
      isSearchVisible: false,
    }),
    computed: {
      ...mapGetters([
        'apiMockEnabled',
      ]),
       mockIconColor() {
        return this.apiMockEnabled ? 'primary' : 'black'
      }
    },
  }
</script>

<style scoped>
.back >>> .v-btn__content {
  flex-direction: column;
  align-items: center;
  font-size: 0.7rem;
  text-transform: initial;
}
.back >>> .v-btn {
  background-color: unset;
  box-shadow: unset;
  border-left: 1px solid #E0E0E0;
  border-radius: unset;
  height: 100%;
  width: unset;
  padding: 0 0.5rem;
  min-width: 3rem;
}
@media (min-width: 600px) {
  .back >>> .v-btn {
    border-width: 2px;
  }
}
@media (min-width: 960px) {
  .back >>> .v-btn {
    padding: 0.8rem;
    min-width: 6rem;
  }
  .back >>> .v-btn__content {
    font-size: 0.85rem;
  }
}
</style>
<style lang="scss" scoped>
.pseudo-visible {
  opacity: 1;
  z-index: 1;
  width: 100%;
  position: initial;
}
.pseudo-hidden {
  opacity: 0;
  z-index: -999;
  position: absolute;
  width: 0px;
}
.search-mobile {
  display: flex !important;
  justify-content: space-between;
  align-items: center;
  transition: all 0.5s;
  column-gap: 1rem;
  & > button {
    text-transform: capitalize;
  }
}
.back {
  transition: all 0.5s;
  &.d-none {
    display: none !important;
  }
  &-inner-container {
    position: absolute;
    height: 100%;
    display: flex;
    padding: unset;
    right: 0;
    column-gap: 0.5rem;
  }
  &-title {
    margin-bottom: 0 !important;
    font-size: 0.75rem !important;
    line-height: 1rem;
  }
  &-buttons {
    height: 100%;
  }
  @media (min-width: 600px) {
    &-inner-container {
      column-gap: 0.3rem;
    }
    &-title {
      font-size: 0.85rem !important;
    }
  }
  @media (min-width: 700px) {
    &-inner-container {
      right: unset;
    }
  }
  @media (min-width: 960px) {
    &-title {
      font-size: 0.9rem !important;
    }
    &-inner-container {
      column-gap: 0.5rem;
    }
  }
}
</style>

<style scoped>
.header {
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: #ccd3de !important;
}
.container {
  margin-top: -2px;
}
.header >>> .v-toolbar__content {
  padding: 0;
}
.menu {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  display: flex;
  align-items: center;
  letter-spacing: 0.1px;
  color: #234025;
  text-decoration: none;
  text-align: right;
  float: right;
}
@media (max-width: 600px) {
  .menu {
    font-size: 10px;
  }
}
.input__wrapper {
  height: 41px;
}
.input__wrapper >>> .v-input__slot {
  border-radius: 0;
}
@media (max-width: 600px) {
  .input__wrapper >>> .v-input__slot {
    padding-left: 4px !important;
  }
}
.v-text-field--outlined >>> fieldset {
  border-color: #ccd3de;
  height: 44px;
}
.v-text-field--outlined >>> .v-label {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.2px;
  color: #a7b3c7;
  margin-top: -6px;
}
</style>
